<template>
    <div class="ocrContainer" :class="mode">
      <div class="btn-area">
         <div class="btn-area-left">
              <el-button class="big-content-btn" size="small" type="primary" @click="openFile">
                  <i class="iconfont">&#xe62f;</i>
                  <span class="btn-text">本地上传</span>
              </el-button>
              <el-button class="big-content-btn" size="small" type="primary" plain @click="showResource">
                  <i class="iconfont">&#xe754;</i>
                  <span class="btn-text">素材库上传</span>
              </el-button>
         </div>
         <div class="btn-area-right">
              <el-button size="small" @click="gotoServiceManage">
                  服务管理
              </el-button>
              <el-button :disabled="!resultText" size="small" @click="downLoadWord">
                  导出Word
              </el-button>
              <el-button :disabled="!resultText" size="small" @click="copyToClipboard">
                  复制结果
              </el-button>
              <el-button :loading="btnLoading" size="small" type="primary" @click="handleSubmit">
                  开始处理
              </el-button>
         </div>
      </div>
      <div v-show="!resourceData.ref_id" class="content-uploader" @dragover.prevent @drop="handleDrop($event)" @click="openFile">
          <i class="iconfont upload-icon">&#xe7ed;</i>
          <span class="upload-title">拖拽或点击上传本地音频</span>
          <span class="upload-subTitle">支持MP3、MAV音频，最大支持10.00MB音频</span>
          <div class="upload-tip">
              <div class="tip-card" v-for="(item, index) in tipList" :key="index">
                  <div class="tip-title">{{ item.title }}</div>
                  <div class="tip-content">{{ item.content }}</div>
              </div>
          </div>
      </div>
      <div class="content-holder" v-show="resourceData.ref_id">
          <div class="content-audio-holder">
                <audio class="content-audio" controls ref="audioRef">
                    <source :src="''"/>
                </audio>
          </div>
          <div class="content-result-holder">
              <div class="ready-holder"  v-show="isShowReadText">
                  <h3 class="ready-title">
                      识别成功后结果将会显示在这里
                  </h3>
                  <div class="ready-content">
                      可进行二次编辑或将结果复制到剪贴板中
                  </div>
              </div>
              <div class="loading-holder" v-show="isShowLoading">
                  <img style="width: 100px; height: 100px;" :src="loadingImg" alt="Animated GTF"/>
                  <span class="showPendingText">结果正在生成中...</span>
              </div>
              <el-input
                class="result-holder"
                v-show="isShowResultText"
                v-model="resultText"
                resize="none"
                type="textarea" />
          </div>
      </div>

      <localAudioFileUploader ref="localAudioFileUploader" @addResource="addResource" />
    </div>
</template>

<script>
  import axios, { CancelTokenSource } from 'axios'
  import { useInitResource, useShowResource, useDestroyResource } from '@/hooks/useResource';
  import localAudioFileUploader from '@/layout/components/localAudioFileUploader.vue';
  import { SUCCESS_STATUS, LoadingStatus } from '../config';
  import loadingImg from '/imgs/AILoading.png';
  import exportWord from '@/utils/exportWord';
  import dayjs from 'dayjs';

  const pendingStatusArray = [LoadingStatus.CREATE, LoadingStatus.ENQUEUE, LoadingStatus.DEQUEUE, LoadingStatus.RUNNING];

  export default {
    name: 'NaturalLanguageSearchTool',
    props: {
        mode: {
            type: String,
        },
        tipList: {
            type: Array,
            default: () => []
        }
    },
    components: {
        localAudioFileUploader,
    },
    data() {
        return {
            source: axios.CancelToken.source(),
            resourceData: {},
            resultText: '',
            usageLogId: undefined,
            btnLoading: false,
            useResource: null,
            pollingTimer: null,
            loadingImg
        }
    },
    computed: {
        isShowReadText() {
            return !this.usageLogId && !this.resultText
        },
        isShowLoading() {
            return !!this.usageLogId
        },
        isShowResultText() {
            return !!this.resultText
        }
    },
    mounted () {
        setTimeout(() => {
            this.useResource = useInitResource({
                multiple: false,
                mode: this.mode,
                tabData: [{
                name: '音频',
                type: 'audio',
                args: [
                    {
                    version: 3,
                    }
                ],
                sort: ["private", "shared", "public"],
                folderNameReplace: [
                    {
                        resKey: "private",
                        replaceName: "个人",
                        hidden: false,
                    },
                    {
                        resKey: "shared",
                        replaceName: "部门",
                        hidden: false,
                    },
                    {
                        resKey: "public",
                        replaceName: "公共",
                        hidden: false,
                    },
                ],
                }]
            }, this.addResource);
        }, 500);
    },
    watch: {
        usageLogId: function(newVal) {
            if (newVal) {
                // 关闭前一次轮询，生成新的source,开始轮训
                this.stopPolling();
                this.generateNewSource();
                this.startPolling();
            } else {
                this.stopPolling();
            }
        },
        resourceData: async function(newVal) {
            if (newVal) {
                this.resetResultText();

                if((/^https:\/\/[^\s/$.?#].[^\s]*$/).test(newVal.url)) {
                try {
                    const response = await fetch(newVal.url);

                    if(response.status >= 400) {
                        this.$message.error('音频文件加载失败');
                        return;
                    }
                } catch(err) {
                    console.error(err);
                }
                }

                this.$refs.audioRef.src= newVal.url;
            }
        }
    },
    methods: {
        startPolling() {
            this.pollingTimer = setInterval(() => {
                this.getCharacterResult()
            }, 3000);
        },
        stopPolling() {
            clearInterval(this.pollingTimer);
        },
        generateNewSource() {
            const source = axios.CancelToken.source();

            this.source = source;
        },
        async handleSubmit() {
            if(!this.resourceData.ref_id) {
                this.$message.warning('请先选择音频')

                return;
            }

            this.resetResultText();

            this.btnLoading  = true;

            const params =  {
                ref_id: this.resourceData.ref_id,
            };

            try {
                const { data } = await axios.post('/index/ai_nls/submit', params);

                if (data.status === SUCCESS_STATUS) {
                    this.usageLogId = data?.data?.usage_log_id;
                } else {
                    this.$message.error(data.error);
                    this.btnLoading  = false;
                }
            } catch(err) {
                this.$message.error(err);
            } finally {
                this.btnLoading  = false;
                this.$emit('updateHistory');
            }
        },
        async getCharacterResult() {
            try {
                const { data } = await axios.get('/index/ai_nls/get_usage_log', {
                    params: {
                        usage_log_id: this.usageLogId
                    },
                    cancelToken: this.source.token
                });

                if (data.status === SUCCESS_STATUS) {
                    this.resultText = data?.data?.text || '';

                    if (!pendingStatusArray.includes(data.data.status)) {
                        this.usageLogId = undefined;
                        this.$emit('updateHistory');
                    }
                } else {
                    this.$message.error(data.error);
                    this.stopPolling();
                }
            } catch(err) {
                console.error(err);
            }
        },
        showResource() {
            useShowResource(this.useResource);
        },
        openFile() {
            this.$refs.localAudioFileUploader.openFile();
        },
        handleDrop(event) {
            event.preventDefault()
            const files = event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                if (files[i].type.startsWith('audio/')) {
                this.$refs.localAudioFileUploader.fileLoad(files[i])
                }
            }
        },
        addResource(resource) {
            const currentResource = Array.isArray(resource) ? resource[0] : resource;

            this.resourceData = currentResource;
            this.resetUsageLogId()
        },
        useHistory(item) {
            const { file_path, text, id, status, ref_id } = item;

            this.source.cancel('操作取消');

            if (pendingStatusArray.includes(status)) {
                this.usageLogId = id;
            } else {
                this.usageLogId = undefined;
            }
            this.resourceData = {
                url: file_path,
                ref_id: ref_id
            };
            setTimeout(() => {
                this.resultText = text;
            });
        },
        resetResultText() {
            this.resultText = '';
        },
        resetUsageLogId() {
            this.usageLogId = undefined;
        },
        gotoServiceManage() {
            window.open('/rm/team/service', '_blank');
        },
        async downLoadWord() {
            const data = {
                aiType: '图片转文字',
                time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                transText: this.resultText,
            }
            try {
                await exportWord(data, 'ai-doc')
            } catch(err) {
                console.error('文档导出失败:', err);
            }
        },
        copyToClipboard() {
            try {
                const textarea = document.createElement('textarea')
                document.body.appendChild(textarea)
                textarea.value = this.resultText
                textarea.select()
                document.execCommand('Copy')
                document.body.removeChild(textarea)
                this.$message.success('复制成功')
                return true
            } catch (e) {
                return false
            }
        },
    },
    beforeDestroy() {
        useDestroyResource(this.useResource);
    }
}
</script>

<style scoped lang="scss">
  .ocrContainer {
      display: flex;
      width: 100%;
      min-width: 500px;
      flex-direction: column;
      min-height: 610px;

      .btn-area {
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;

          .btn-area-left {
              display: flex;
              .iconfont {
                  position: relative;
                  top: 1px;
                  margin-right: 3px;
              }
              ::v-deep .big-content-btn {
                  padding: 7px 15px;
                  span {
                    display: flex;
                    align-items: center;
                  }
                  .iconfont {
                    font-size: 20px;
                    margin-right: 3px;
                  }
              }
          }
      }

      .content-uploader {
          cursor: pointer;
          display: flex;
          flex: 1;
          background-color: #F5F5F5;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .upload-icon {
              color: #CCCCCC;
              font-size: 60px;
              margin-bottom: 5px;
          }
          .icon {
              color: #CCCCCC;
              font-size: 60px;
              margin-bottom: 5px;
          }
          .upload-title {
              font-size: 20px;
              color: #333333;
              font-weight: 600;
          }
          .upload-subTitle {
              margin-top: 10px;
              font-size: 14px;
              color: #999999;
          }
          .upload-tip {
              margin-top: 40px;
              display: flex;
              justify-content: space-around;
              .tip-card {
                  margin: 0 15px;
                  min-width: 220px;
                  max-width: 300px;
                  height: 80px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  background-color: #FFFFFF;
                  border-radius: 3px;
                  padding: 0 20px;
                  .tip-title {
                      font-size: 14px;
                      color: #666666;
                  }
                  .tip-content {
                      margin-top: 10px;
                      font-size: 13px;
                      color: #999999;
                  }
              }
          }
      }

      .content-holder {
          width: 100%;
          height: 100%;
          display: flex;
          min-height: 550px;
          .content-audio-holder {
              width: 50%;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              border-left: 1px solid #DDDDDD;
              border-top: 1px solid #DDDDDD;
              border-bottom: 1px solid #DDDDDD;
          }

          .content-result-holder {
              width: 50%;

              .ready-holder {
                  width: 100%;
                  height: 100%;
                  min-height: 550px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #DDDDDD;
                  h3 {
                      color: #666;
                      font-size: 20px;
                  }

                  .ready-content {
                      font-size: 14px;
                      color: #999;
                      text-align: center;
                      line-height: 30px;
                  }
              }

              .loading-holder {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #DDDDDD;

                  .showPendingText {
                      font-size: 18px;
                      background-image: linear-gradient(to right, #E7B0E6 100%, #9371FF 100%, #49A3FF 100%);
                      -webkit-background-clip: text;
                      background-clip: text;
                      -webkit-text-fill-color: transparent;
                  }
              }

              .result-holder {
                  width: 100%;
                  height: 100%;
                  font-size: 14px;
                  color: #333333;
                  line-height: 24px;
                  word-break: break-word;
              }

              ::v-deep .el-textarea__inner {
                  border-radius: 0;
                  height: 100%;
              }

              ::v-deep .el-textarea__inner:focus, .el-textarea__inner:active {
                  border: 1px solid #DDDDDD !important;
              }
          }
      }
  }

  .h5 {
      .btn-area{
          .btn-area-right {
              .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
                  color: #666666;
              }
          }
      }
      .content-uploader {
          background-color: #2A2A2A;

          .upload-icon {
              color: #BBBBBB;
          }

          .upload-title {
              font-size: 20px;
              color: #BBBBBB;
          }
          .upload-subTitle {
              font-size: 14px;
              color: #999999;
          }

          .upload-tip {
              .tip-card {
                  background-color: #333333;
                  border-radius: 3px;
                  font-size: 14px;
                  color: #999999;

                  .tip-title {
                      color: #999999;
                  }

                  .tip-content {
                      color: #999999;
                  }
              }
          }
      }
      .content-holder {
          background-color: #2A2A2A;
          .content-audio-holder {
              border-left: 1px solid #2A2A2A;
              border-top: 1px solid #2A2A2A;
              border-bottom: 1px solid #2A2A2A;
              border-right: 1px solid #333;
          }
          .content-result-holder {
              border: 1px solid #2A2A2A;
              ::v-deep .el-textarea__inner {
                  border: 1px solid #2A2A2A;
                  background: #2A2A2A
              }

              .ready-holder {
                  border: 1px solid #2A2A2A;

                  h3 {
                      color: #BBBBBB;
                      margin-block-start: 0px;
                      margin-block-end: 0px;
                  }
                  .ready-content {
                      color: #999999;
                  }
              }

              .loading-holder {
                  border: 1px solid #2A2A2A;
              }

              .result-holder {
                  border: 1px solid #2A2A2A;
              }

              ::v-deep .el-textarea__inner:focus, .el-textarea__inner:active {
                  border: 1px solid #2A2A2A !important;
              }
          }
      }
  }
  .rich {
      .btn-area{
          .btn-area-right {
              .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
                  color: #999;
              }
          }
      }
  }
</style>
